<template>
     <section class="question">
        <Nav title="常见问题" />
        <van-tabs v-model="active">
            <van-tab title="认证问题">
                <van-collapse v-model="activeNames">
                    <van-collapse-item title="认证审核需要提交什么材料？" name="1">
                        <p>一、如果你是员工，提供：</p>
                        <p>1. 身份证正反面照片；<br> 2. 手持身份证照片；<br> 3. 在职证明/劳动合同/工牌（最好盖有公司公章）/有公司和个人信息的社保缴纳证明/实名认证过的钉钉或企业微信截图/公司logo同框照片/名片，其中至少一个。</p>
                        <p>共计2张照片提交认证即可。</p>
						<p> 二、如果你是法定代表人，提供： </p>
						<p>1. 身份证正反面照片；<br> 2. 手持身份证照片；<br> 3. 在职证明/劳动合同/手持最新营业执照，其中至少一个。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="认证失败一般有哪些原因？" name="2">
						<p>1. 输入信息不准确，比如姓名，身份证号输入不对，公司名称输入不完整（这个原因特别多，希望引起大家注意，比如少写了“咨询”，“服务”，“信息”等字眼）；</p>
						<p>2. 提供的资料和公司对不上；</p>
						<p>3. 资料虚假。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="认证需要多久才能通过？" name="3">
                        <p>1. 工作日提交认证，1个工作日完成审核；</p>
                        <p>2. 非工作日提交认证，1-2个工作日完成审核。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="认证失败，如何能通过闪电抢单认证？" name="4">
                        <p>信贷经理审核标准是多维度的，请按照短信/App推送提示， 上传相关证明材料，即可通过认证。</p>
                    </van-collapse-item>
                </van-collapse>

				<van-collapse v-model="activeNames">
                    <van-collapse-item title="认证时，身份证等照片无法上传？" name="5">
                        <p>请保证照片大小不超过5M，否则无法上传。如还不行请把app缓存清除一下，或者卸载app重新安装。如还不能解决，请联系客服。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="换了公司，换了城市怎么更改？" name="5">
                        <p>您好，换公司或换城市需要重新认证，app【我的】-【信贷经理认证】页面-点击右上角【重新认证】进行更换资料或公司。</p>
                    </van-collapse-item>
                </van-collapse>
            </van-tab>
            <van-tab title="充值问题">
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="最低可以充值多少？有几档充值套餐？" name="20">
                        <p>你好，最低充值一般是298元，套餐档一般有298元，588元，998元，1598元，1998元等。可能会有增减，请以充值界面为准。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="平台的支付币是否存在有效期？" name="21">
                        <p>充值的服务代购币是没有有效期限制的，充值后永久有效。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="充值未到账，如何解决？" name="22">
                        <p>您好，请联系App在线人工客服，将会帮您核实解决问题。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="充值之后的账户余额可不可以退款、提现？" name="22">
                        <p>目前平台充值的账户余额不可退款、提现，也无法转赠、转让，这一点在您充值时的用户协议里也有提醒的，请知悉。</p>
                    </van-collapse-item>
                </van-collapse>
			</van-tab>
            <van-tab title="获客退单">
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="平台订单是需要自己接，还是会推送？" name="30">
                        <p>目前平台订单均是需要用户主动接单，选择您需要的订单直接接单即可。会员用户可以享受智能匹配服务，系统为您匹配符合您选择条件的订单。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="收不到平台推送的订单" name="31">
                        <p>您可以点击App【订单】右上角的「筛选」，重置筛选条件。若不能解决，请联系App在线客服。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="电话联系客户，为何经常提示客户手机号为空号？" name="32">
                        <p>平台为保证客户隐私安全，您所拨打的客户号码为虚拟号码。客户接收的为您真实号码（当然您也可以选择隐藏你的号码）。您每次联系客户时，务必用接单手机号登录App，通过App启动电话联系，否则呼出无效。</p>
                    </van-collapse-item>
                </van-collapse>
				<van-collapse v-model="activeNames">
                    <van-collapse-item title="可以退单吗？退单规则是啥？" name="33">
                        <p>你好，可以退单，退单规格大致如下：</p>
						<p> 1. 时效性：最快30分钟之后才可以退单，最迟3天内要退单。联系不上/不接电话的要打2天6次电话之后才可以提交退单申请；<br> 2. 空号/停机：退；<br> 3. 关机/无人接听：退，但需提供2天内6次联系证明；<br> 4. 客户无意向/未申请/不需要：退，需提供通话录音或者聊天截图证明。 </p>
						<p>详细退单规则请关注微信公众号查看。</p>
                    </van-collapse-item>
                </van-collapse>
			</van-tab>
        </van-tabs>
    </section>
</template>

<script>
import Nav from "components/Nav";

export default {
    name: "question",
    components: {
        Nav,
    },
    data() {
        return {
            active: 0,
            activeNames: [0],
        };
    },
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {},
};
</script>

<style lang="scss">
.question {
    padding-top: 46px;
    .van-tabs__wrap {
        .van-tab {
            color: #2b2f3a;
        }
        .van-tab__text {
            font-size: 16px;
        }
        .van-tab--active {
            color: #3A5EEC;
        }
    }
    .van-tabs__line {
        width: 26px;
        height: 3px;
        background: #3A5EEC;
        border-radius: 1px;
    }
	.van-cell {
		height: 57px;
		align-items: center;
		padding: 0 16px;
		color: #2B2F3A;
	}
	.van-cell__title {
		font-size: 16px;
	}
	.van-icon__image, .check {
		width: 26px;
		height: 26px;
	}
	.van-cell__right-icon {
		font-size: 18px;
		color: #2B2F3A;
	}
    .van-collapse-item__title--expanded::after,
    .van-cell::after {
        display: none;
    }
    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border: 0;
        border-top: 1px solid #f6f6f6;
    }
    .van-collapse-item__content {
        color: #575e72;
        font-size: 14px;
        p {
            padding-bottom: 8px;
        }
    }
	
}
</style>


// WEBPACK FOOTER //
// src/views/user/question/Question.vue